@import '../../../styles/vars.css';

.root {
  min-width: 40px;
  color: var(--action-active);
  flex-shrink: 0;
  display: inline-flex;
}

.alignItemsFlexStart {
  margin-top: 8px;
}
